export default "__VITE_ASSET__BVYvl9Rc__"